export type SearchStatus = 'found' | 'not_found' | 'incomplete' | 'unavailable' | 'not_searched'
export type MatchingSearch = Record<'orders' | 'requests', { status: SearchStatus; note?: string }>
const statusLabels: Record<SearchStatus, string> = {
  found: 'найдено основание', not_found: 'подходящее основание не найдено',
  incomplete: 'поиск не завершён', unavailable: 'источник недоступен', not_searched: 'поиск не выполнялся',
}
export const matchingStatus = (search: MatchingSearch | undefined, datasets: string[]) => {
  const order = datasets.includes('orders') || search?.orders.status === 'found'
  const request = datasets.includes('requests') || search?.requests.status === 'found'
  const description = search ? (['orders', 'requests'] as const).map(dataset =>
    `${dataset === 'orders' ? 'Заказы поставщику' : 'Заявки на закупку'}: ${statusLabels[search[dataset].status]}.${search[dataset].note ? ` ${search[dataset].note}` : ''}`).join(' ') :
    'В этом разборе не сохранён отдельный итог поиска заказов и заявок. Отсутствие связи не означает, что документов нет в 1С.'
  const result = (key: string, label: string, color: string) => ({ key, label, color, description })
  if (order && request) return result('mixed', 'Найдены заказ и заявка', 'blue')
  if (order) return result('order', 'Найден заказ', 'success')
  if (request) return search?.orders.status === 'not_found'
    ? result('request_fallback', 'Заказ не найден · найдена заявка', 'gold')
    : result('request', 'Найдена заявка · заказ не проверен полностью', 'gold')
  if (search?.orders.status === 'not_found' && search.requests.status === 'not_found')
    return result('missing', 'Заказ и заявка не найдены', 'error')
  if (search?.orders.status === 'unavailable' || search?.requests.status === 'unavailable')
    return result('unavailable', 'Не удалось проверить основания', 'gold')
  if (search?.orders.status === 'incomplete' || search?.requests.status === 'incomplete')
    return result('incomplete', 'Поиск основания не завершён', 'gold')
  if (search?.orders.status === 'not_found') return result('order_missing', 'Заказ не найден · заявка не проверена', 'gold')
  if (search?.requests.status === 'not_found') return result('request_missing', 'Заявка не найдена · заказ не проверен', 'gold')
  return result('unknown', 'Основание не определено', 'default')
}
